import { Feature, Point, Polygon } from 'geojson';

import { GEOJSON_GEOMETRY_TYPES, GeoJSON } from './api/datasets';

function closeLinearRing(ring: number[][]): number[][] {
  const firstPosition = ring[0];
  const lastPosition = ring[ring.length - 1];
  if (firstPosition[0] === lastPosition[0] && firstPosition[1] === lastPosition[1]) {
    return ring;
  }
  return ring.concat([firstPosition.slice()]);
}

/**
 * Adapts a stored area into a polygon Feature that Turf accepts, or null when the area
 * holds no usable polygon.
 */
export function asTurfPolygon(area: GeoJSON | null): Feature<Polygon> | null {
  if (!area || area.geometry.type !== GEOJSON_GEOMETRY_TYPES.POLYGON) {
    return null;
  }
  const rings = area.geometry.coordinates as number[][][];
  const outerRing = rings[0];
  if (!Array.isArray(outerRing) || outerRing.length === 0 || !Array.isArray(outerRing[0])) {
    return null;
  }
  return {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Polygon',
      coordinates: rings.map(closeLinearRing),
    },
  };
}

/**
 * Adapts a stored area into a Feature that Turf accepts, or null when the area holds no
 * usable geometry. Point areas pass through; polygon areas get their rings closed.
 */
export function asTurfFeature(area: GeoJSON | null): Feature<Polygon | Point> | null {
  if (area && area.geometry.type === GEOJSON_GEOMETRY_TYPES.POINT) {
    return {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'Point',
        coordinates: (area.geometry.coordinates as number[]).slice(),
      },
    };
  }
  return asTurfPolygon(area);
}
